import { render } from "./Slider2.vue?vue&type=template&id=6c2108b4"
import script from "./Slider2.vue?vue&type=script&lang=js"
export * from "./Slider2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__